var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    width: 16,
    height: 16,
    "data-name": "Layer 2",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    fill: "#004ab9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7283",
    d: "M8.667 2a6.667 6.667 0 1 0 6.667 6.667A6.667 6.667 0 0 0 8.667 2zm.667 9.333a.667.667 0 0 1-1.333 0V8a.667.667 0 0 1 1.332 0zm-.667-4.666A.667.667 0 1 1 9.333 6a.667.667 0 0 1-.666.667z",
    "data-name": "Path 7283",
    transform: "translate(-.667 -.667)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon-information.997d5332dc3539bb5803aedd289f4c03.svg";
export { ForwardRef as ReactComponent };